module.exports = __webpack_public_path__ + "static/two-2bec7ee0685f8cc7ad0d5c833904e25c.png";